/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Drawer_Add_Tool_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Name a tool…" |
*
* @param {Rights_Tools_Drawer_Add_Tool_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_drawer_add_tool_placeholder = /** @type {((inputs?: Rights_Tools_Drawer_Add_Tool_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Drawer_Add_Tool_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tool benennen…")
	return /** @type {LocalizedString} */ ("Name a tool…")
});